import { AprDetails } from './types';
import { getMarketIconSrc } from 'src/components/Utils/MarketIcon';
import { getApyFromApr } from 'src/utils/borrowLend';
import { SanctumApiResponse } from './types';
import { JlpPoolData } from './types';
import { SpotMarketConfig } from '@velocity-exchange/sdk';

/**
 * Process Sanctum LST data into native APY breakdowns
 */
export function processSanctumLstData(
	sanctumData: SanctumApiResponse,
	spotMarkets: SpotMarketConfig[]
): Record<number, AprDetails[]> {
	const result: Record<number, AprDetails[]> = {};

	Object.keys(sanctumData.apys).forEach((key) => {
		const marketIndex = spotMarkets.find(
			(mkt) => mkt.symbol === key
		)?.marketIndex;
		if (marketIndex !== undefined) {
			result[marketIndex] = [
				{
					type: 'native',
					source: `${key} APY`,
					apy: sanctumData.apys[key] * 100,
				},
			];
		}
	});

	return result;
}

/**
 * Process JLP data into native APY breakdown
 */
export function processJlpData(
	jlpData: JlpPoolData,
	JLP_POOL_JLP_MARKET_INDEX: number,
	JLP_MARKET_INDEX: number
): Record<number, AprDetails[]> {
	const newApr = jlpData.feeAprBps / 100;
	const newApy = getApyFromApr(newApr, 'hourly');

	const jlpMetric = {
		type: 'native' as const,
		source: 'JLP Fees Yield',
		apy: newApy,
		apr: newApr,
		icon: getMarketIconSrc({ baseSymbol: 'jlp' }),
	};

	return {
		[JLP_POOL_JLP_MARKET_INDEX]: [jlpMetric],
		[JLP_MARKET_INDEX]: [jlpMetric],
	};
}
